import B_Define from '../util/B_Define';

const B_Tick = (function(){
	return class {
		constructor(canvas) { }

		/**
         * [ Function :: tickVariableReload ]
         *
         * @DES :: 변수 실시간 처리
         * @IP1 :: world {object}
         * @O.P :: null
         */
		static tickVariableReload (world) {
			Object.values(world.LIST[B_Define.VARIABLE_TYPE]).forEach((e) => {
				const VARIABLE = world.LIST[B_Define.VARIABLE_REAL_TYPE][e.variable];
				if (typeof VARIABLE !== 'undefined') e.value = VARIABLE.value;
			});
		}
	};
}());

export default B_Tick;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/frame/B_Tick.js